const bannerImages = [
  {
    link: 'baby',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER4.jpg',
  },
  {
    link: 'gadgets',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER3.jpg',
  },
  {
    link: 'beauty',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER1.jpg',
  },
]

const domain = 'luxuracart.com'
const domainName = 'luxuracart'
const domainLogo = '/luxura-cart-logo-white-gold-cropped.png'
const bgColor = '#000'
const favicon = '/favicon.ico'
const email = 'cs@luxuracart.com'
const emailGlobal = 'gcc@luxuracart.com'
const metaTitle = 'Shop Premium USA Brands Online at Luxura Cart &ndash; Luxura Cart'
const metaDescription = 'Buy online Premium USA Brands from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
const headerBg = '#000'
const subMenu = '#000'
const bannesImages = bannerImages
const buttonColor = '#f7f7f7'
const address = '707/lotus Bussiness Park, Ram Baug Lane, Off Sv Road,<br /> Malad West, Mumbai, India - 400064'
const phone = '+91- 9653498993'
const addressGlobal = 'AMC Boulevard Building,<br />Ajman Media City,<br /> Ajman, United Arab Emirates'
const phoneGlobal = '+971 4 836 9557'

const Host = {
  domain: domain,
  domainName: domainName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannesImages: bannesImages,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
  emailGlobal: emailGlobal,
  addressGlobal: addressGlobal,
  phoneGlobal: phoneGlobal
}


export default Host;